import { render, staticRenderFns } from "./DetailLahanSostamMap.vue?vue&type=template&id=1eed732b"
import script from "./DetailLahanSostamMap.vue?vue&type=script&lang=js"
export * from "./DetailLahanSostamMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports